import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { Tooltip } from '../../../../common/tooltip'
import { deleteTypes } from '../constant'
import classes from './index.module.scss'
import { selectById, uncheckItem } from './store/slice'

const Action = ({
  rowId,
  deleteTemplate,
  openTemplate,
  setDefaultTemplate,
  nameKey,
  typeTemplate,
  idKey,
  page,
  pageSize,
  defaultTemplate,
}) => {
  const dispatch = useDispatch()

  const byId = useSelector(selectById)

  const [isShowPopupDefault, setIsShowPopupDefault] = useState(false)
  const [isShowPopupDelete, setIsShowPopupDelete] = useState(false)

  const template = byId[rowId]

  const isDefault = template.isDefault

  const isFiinGateTemplate = template.isFiinGateTemplate

  const isDisableDelete = isDefault || isFiinGateTemplate

  const open = () => openTemplate(template)

  const setDefault = () => {
    setDefaultTemplate({
      param: { [idKey]: template[idKey], templateType: typeTemplate },
      paramGet: {
        Page: page,
        PageSize: pageSize,
        TemplateType: typeTemplate,
      },
    })
    closePopupDefault()
  }

  const deleteAction = () => {
    deleteTemplate({
      param: {
        ids: [template[idKey]],
        templateType: typeTemplate,
        deleteType: deleteTypes.IN,
      },
      paramGet: {
        Page: page,
        PageSize: pageSize,
        TemplateType: typeTemplate,
      },
    })
    dispatch(uncheckItem(template[idKey]))
    closePopupDelete()
  }

  const openPopupDefault = () => setIsShowPopupDefault(true)

  const closePopupDefault = () => setIsShowPopupDefault(false)

  const openPopupDelete = () => setIsShowPopupDelete(true)

  const closePopupDelete = () => setIsShowPopupDelete(false)

  return (
    <div className="dFlex alignItemsCenter">
      <Tooltip isI18n tooltipContent="preferenceSetting.OPEN">
        <Icon
          style={{ fontSize: 15, color: '#0553A5' }}
          className="icon-open-new"
          onClick={open}
        />
      </Tooltip>
      <div className={classes.ml12}>
        <Tooltip
          isI18n
          tooltipContent="preferenceSetting.SET_DEFAULT"
          contentStyle={{
            transform: isDefault ? 'rotate(-90deg)' : 'unset',
          }}
        >
          <Icon
            style={{
              fontSize: 15,
              color: !isDefault ? '#0553A5' : '#D5D5D5',
            }}
            onClick={!isDefault ? openPopupDefault : undefined}
            className="icon-pin-fill"
          />
        </Tooltip>
      </div>
      <div className={classes.ml12}>
        <Tooltip isI18n tooltipContent="preferenceSetting.REMOVE">
          <Icon
            style={{
              fontSize: 15,
              color: !isDisableDelete ? '#9C9C9C' : '#D5D5D5',
            }}
            className="icon-trash-fill"
            onClick={!isDisableDelete ? openPopupDelete : undefined}
          />
        </Tooltip>
      </div>
      <PopupAction
        isShow={isShowPopupDefault}
        title="preferenceSetting.CONFIRMATION"
        handleClose={closePopupDefault}
        btnCancel={{
          label: 'common.NO',
          event: closePopupDefault,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: setDefault,
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.SET_DEFAULT_CONFIRM_1" />
        <br />
        <Translate value="preferenceSetting.SET_DEFAULT_CONFIRM_2" />
        <span className="fw600">{defaultTemplate[nameKey]}</span>
      </PopupAction>
      <PopupAction
        isShow={isShowPopupDelete}
        title="preferenceSetting.CONFIRMATION_2"
        handleClose={closePopupDelete}
        btnCancel={{
          label: 'common.NO',
          event: closePopupDelete,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: deleteAction,
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.DELETE_CONFIRM_1" />
        <span className="fw600">{template[nameKey]}</span>
        <Translate value="preferenceSetting.DELETE_CONFIRM_2" />
      </PopupAction>
    </div>
  )
}

Action.propTypes = {
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isActive: PropTypes.bool,
}

export default Action
